import { Button } from "@/components/ui/button";
import { Loader2, PauseCircle, PlayCircle } from 'lucide-react';
import { useNotify, useRecordContext, useUpdate } from 'ra-core';
import { useState } from 'react';
import { useHasPermission } from '../rbac/useHasPermission';

export const HoldVendorButton = () => {
    const record = useRecordContext();
    const notify = useNotify();
    const [update, { isPending }] = useUpdate();
    const [loading, setLoading] = useState(false);
    const { hasPermission: canManage } = useHasPermission('manage_procurement');

    if (!record || record.status === 'blacklisted' || !canManage) return null;

    const onHold = record.status === 'on_hold';
    const nextStatus = onHold ? 'pending_approval' : 'on_hold';

    const handleToggle = () => {
        setLoading(true);
        update(
            'vendors',
            { id: record.id, data: { status: nextStatus }, previousData: record },
            {
                onSuccess: () => {
                    notify(onHold ? 'Vendor released from hold' : 'Vendor put on hold', { type: 'success' });
                    setLoading(false);
                },
                onError: (error: any) => {
                    notify(`Error updating vendor: ${error.message}`, { type: 'error' });
                    setLoading(false);
                },
            }
        );
    };

    return (
        <Button
            onClick={handleToggle}
            disabled={loading || isPending}
            variant="outline"
            size="sm"
            className="text-amber-700 border-amber-200 hover:bg-amber-50 gap-2"
        >
            {loading ? (
                <Loader2 className="w-4 h-4 animate-spin" />
            ) : onHold ? (
                <PlayCircle className="w-4 h-4" />
            ) : (
                <PauseCircle className="w-4 h-4" />
            )}
            {onHold ? 'Release Hold' : 'Put On Hold'}
        </Button>
    );
};
